// https://gist.github.com/mikemunsie/d58d88cad0281e4b187b0effced769b2
// https://howtophoneto.com/
// https://stackoverflow.com/a/72255918

export interface InternationalPhoneNumber {
  code: string;
  dial_code: string;
  mask: string;
  name: string;
  min?: number;
}

export const internationalPhoneMask: InternationalPhoneNumber[] = [
  {
    code: 'AF',
    dial_code: '+93',
    mask: '+93 99 999 9999',
    name: 'Afghanistan'
  },
  {
    code: 'AX',
    dial_code: '+358',
    mask: '+358 9999999999',
    name: 'Aland Islands'
  },
  {
    code: 'AL',
    dial_code: '+355',
    mask: '+355 (999) 999 999',
    name: 'Albania'
  },
  { code: 'DZ', dial_code: '+213', mask: '+213 99 999 9999', name: 'Algeria' },
  {
    code: 'AS',
    dial_code: '+1684',
    mask: '+1 (684) 999 9999',
    name: 'AmericanSamoa'
  },
  { code: 'AD', dial_code: '+376', mask: '+376 999 999', name: 'Andorra' },
  { code: 'AO', dial_code: '+244', mask: '+244 (999) 999 999', name: 'Angola' },
  {
    code: 'AI',
    dial_code: '+1264',
    mask: '+1 (264) 999 9999',
    name: 'Anguilla'
  },
  { code: 'AQ', dial_code: '+672', mask: '+672 199 999', name: 'Antarctica' },
  {
    code: 'AG',
    dial_code: '+1268',
    mask: '+1 (268) 999 9999',
    name: 'Antigua and Barbuda'
  },
  {
    code: 'AR',
    dial_code: '+54',
    mask: '+54 (999) 999 9999',
    name: 'Argentina'
  },
  { code: 'AM', dial_code: '+374', mask: '+374 99 999 999', name: 'Armenia' },
  { code: 'AW', dial_code: '+297', mask: '+297 999 9999', name: 'Aruba' },
  { code: 'AU', dial_code: '+61', mask: '+61 9 9999 9999', name: 'Australia' },
  { code: 'AT', dial_code: '+43', mask: '+43 (999) 999 9999', name: 'Austria' },
  {
    code: 'AZ',
    dial_code: '+994',
    mask: '+994 99 999 99 99',
    name: 'Azerbaijan'
  },
  {
    code: 'BS',
    dial_code: '+1242',
    mask: '+1 (242) 999 9999',
    name: 'Bahamas'
  },
  { code: 'BH', dial_code: '+973', mask: '+973 9999 9999', name: 'Bahrain' },
  {
    code: 'BD',
    dial_code: '+880',
    mask: '+880 99 999 999',
    name: 'Bangladesh'
  },
  {
    code: 'BB',
    dial_code: '+1246',
    mask: '+1 (246) 999 9999',
    name: 'Barbados'
  },
  {
    code: 'BY',
    dial_code: '+375',
    mask: '+375 (99) 999 99 99',
    name: 'Belarus'
  },
  { code: 'BE', dial_code: '+32', mask: '+32 (999) 999 999', name: 'Belgium' },
  { code: 'BZ', dial_code: '+501', mask: '+501 999 9999', name: 'Belize' },
  { code: 'BJ', dial_code: '+229', mask: '+229 99 99 9999', name: 'Benin' },
  {
    code: 'BM',
    dial_code: '+1441',
    mask: '+1 (441) 999 9999',
    name: 'Bermuda'
  },
  {
    code: 'BT',
    dial_code: '+975',
    mask: '+975 9 999 999',
    name: 'Bhutan',
    min: 9
  },
  {
    code: 'BO',
    dial_code: '+591',
    mask: '+591 9 999 9999',
    name: 'Bolivia, Plurinational State of'
  },
  {
    code: 'BA',
    dial_code: '+387',
    mask: '+387 99 99999',
    name: 'Bosnia and Herzegovina',
    min: 9
  },
  { code: 'BW', dial_code: '+267', mask: '+267 99 999 999', name: 'Botswana' },
  {
    code: 'BR',
    dial_code: '+55',
    mask: '+55 99999999999',
    name: 'Brazil',
    min: 12
  },
  {
    code: 'IO',
    dial_code: '+246',
    mask: '+246 999 9999',
    name: 'British Indian Ocean Territory'
  },
  {
    code: 'BN',
    dial_code: '+673',
    mask: '+673 999 9999',
    name: 'Brunei Darussalam'
  },
  {
    code: 'BG',
    dial_code: '+359',
    mask: '+359 (999) 999 999',
    name: 'Bulgaria'
  },
  {
    code: 'BF',
    dial_code: '+226',
    mask: '+226 99 99 9999',
    name: 'Burkina Faso'
  },
  { code: 'BI', dial_code: '+257', mask: '+257 99 99 9999', name: 'Burundi' },
  { code: 'KH', dial_code: '+855', mask: '+855 99 999 999', name: 'Cambodia' },
  { code: 'CM', dial_code: '+237', mask: '+237 9999 9999', name: 'Cameroon' },
  { code: 'CA', dial_code: '+1', mask: '+1 (999) 999 9999', name: 'Canada' },
  {
    code: 'CV',
    dial_code: '+238',
    mask: '+238 (999) 99 99',
    name: 'Cape Verde'
  },
  {
    code: 'KY',
    dial_code: '+ 345',
    mask: '+1 (345) 999 9999',
    name: 'Cayman Islands'
  },
  {
    code: 'CF',
    dial_code: '+236',
    mask: '+236 99 99 9999',
    name: 'Central African Republic'
  },
  { code: 'TD', dial_code: '+235', mask: '+235 99 99 99 99', name: 'Chad' },
  { code: 'CL', dial_code: '+56', mask: '+56 9 9999 9999', name: 'Chile' },
  { code: 'CN', dial_code: '+86', mask: '+86 999 999 9999', name: 'China' },
  {
    code: 'CX',
    dial_code: '+61',
    mask: '+61 9 9999 9999',
    name: 'Christmas Island'
  },
  {
    code: 'CC',
    dial_code: '+61',
    mask: '+61 9 9999 9999',
    name: 'Cocos (Keeling) Islands'
  },
  {
    code: 'CO',
    dial_code: '+57',
    mask: '+57 (999) 999 9999',
    name: 'Colombia'
  },
  { code: 'KM', dial_code: '+269', mask: '+269 99 99999', name: 'Comoros' },
  { code: 'CG', dial_code: '+242', mask: '+242 99 999 9999', name: 'Congo' },
  {
    code: 'CD',
    dial_code: '+243',
    mask: '+243 (999) 999 999',
    name: 'Congo, The Democratic Republic of the Congo'
  },
  { code: 'CK', dial_code: '+682', mask: '+682 99 999', name: 'Cook Islands' },
  { code: 'CR', dial_code: '+506', mask: '+506 9999 9999', name: 'Costa Rica' },
  {
    code: 'CI',
    dial_code: '+225',
    mask: '+225 99 999 999',
    name: "Cote d'Ivoire"
  },
  { code: 'HR', dial_code: '+385', mask: '+385 99 999 999', name: 'Croatia' },
  { code: 'CU', dial_code: '+53', mask: '+53 9 999 9999', name: 'Cuba' },
  { code: 'CY', dial_code: '+357', mask: '+357 99 999 999', name: 'Cyprus' },
  {
    code: 'CZ',
    dial_code: '+420',
    mask: '+420 (999) 999 999',
    name: 'Czech Republic'
  },
  { code: 'DK', dial_code: '+45', mask: '+45 99 99 99 99', name: 'Denmark' },
  { code: 'DJ', dial_code: '+253', mask: '+253 99 99 99 99', name: 'Djibouti' },
  {
    code: 'DM',
    dial_code: '+1767',
    mask: '+1 (767) 999 9999',
    name: 'Dominica'
  },
  {
    code: 'DO',
    dial_code: '+1849',
    mask: '+1 (849) 999 9999',
    name: 'Dominican Republic'
  },
  { code: 'EC', dial_code: '+593', mask: '+593 9 9999 999', name: 'Ecuador' },
  { code: 'EG', dial_code: '+20', mask: '+20 (999) 999 9999', name: 'Egypt' },
  {
    code: 'SV',
    dial_code: '+503',
    mask: '+503 99 99 9999',
    name: 'El Salvador'
  },
  {
    code: 'GQ',
    dial_code: '+240',
    mask: '+240 99 999 9999',
    name: 'Equatorial Guinea'
  },
  { code: 'ER', dial_code: '+291', mask: '+291 9 999 999', name: 'Eritrea' },
  {
    code: 'EE',
    dial_code: '+372',
    mask: '+372 99999999',
    name: 'Estonia',
    min: 10
  },
  { code: 'ET', dial_code: '+251', mask: '+251 99 999 9999', name: 'Ethiopia' },
  {
    code: 'FK',
    dial_code: '+500',
    mask: '+500 99999',
    name: 'Falkland Islands (Malvinas)'
  },
  {
    code: 'FO',
    dial_code: '+298',
    mask: '+298 999 999',
    name: 'Faroe Islands'
  },
  { code: 'FJ', dial_code: '+679', mask: '+679 99 99999', name: 'Fiji' },
  {
    code: 'FI',
    dial_code: '+358',
    mask: '+358 (999) 999 99 99',
    name: 'Finland'
  },
  { code: 'FR', dial_code: '+33', mask: '+33 (999) 999 999', name: 'France' },
  {
    code: 'GF',
    dial_code: '+594',
    mask: '+594 99999 9999',
    name: 'French Guiana'
  },
  {
    code: 'PF',
    dial_code: '+689',
    mask: '+689 99 99 99',
    name: 'French Polynesia'
  },
  { code: 'GA', dial_code: '+241', mask: '+241 9 99 99 99', name: 'Gabon' },
  { code: 'GM', dial_code: '+220', mask: '+220 (999) 99 99', name: 'Gambia' },
  {
    code: 'GE',
    dial_code: '+995',
    mask: '+995 (999) 999 999',
    name: 'Georgia'
  },
  { code: 'DE', dial_code: '+49', mask: '+49 99999999999', name: 'Germany' },
  { code: 'GH', dial_code: '+233', mask: '+233 (999) 999 999', name: 'Ghana' },
  { code: 'GI', dial_code: '+350', mask: '+350 999 99999', name: 'Gibraltar' },
  { code: 'GR', dial_code: '+30', mask: '+30 (999) 999 9999', name: 'Greece' },
  { code: 'GL', dial_code: '+299', mask: '+299 99 99 99', name: 'Greenland' },
  {
    code: 'GD',
    dial_code: '+1473',
    mask: '+1 (473) 999 9999',
    name: 'Grenada'
  },
  {
    code: 'GP',
    dial_code: '+590',
    mask: '+590 999 99 99 99',
    name: 'Guadeloupe'
  },
  { code: 'GU', dial_code: '+1671', mask: '+1 (671) 999 9999', name: 'Guam' },
  { code: 'GT', dial_code: '+502', mask: '+502 9 999 9999', name: 'Guatemala' },
  { code: 'GG', dial_code: '+44', mask: '+44 9999 999999', name: 'Guernsey' },
  { code: 'GN', dial_code: '+224', mask: '+224 99 999 999', name: 'Guinea' },
  {
    code: 'GW',
    dial_code: '+245',
    mask: '+245 9 999999',
    name: 'Guinea-Bissau'
  },
  { code: 'GY', dial_code: '+595', mask: '+592 999 9999', name: 'Guyana' },
  { code: 'HT', dial_code: '+509', mask: '+509 99 99 9999', name: 'Haiti' },
  {
    code: 'VA',
    dial_code: '+379',
    mask: '+39 6 698 99999',
    name: 'Holy See (Vatican City State)'
  },
  { code: 'HN', dial_code: '+504', mask: '+504 9999 9999', name: 'Honduras' },
  { code: 'HK', dial_code: '+852', mask: '+852 9999 9999', name: 'Hong Kong' },
  { code: 'HU', dial_code: '+36', mask: '+36 (999) 999 999', name: 'Hungary' },
  { code: 'IS', dial_code: '+354', mask: '+354 999 9999', name: 'Iceland' },
  { code: 'IN', dial_code: '+91', mask: '+91 (9999) 999 999', name: 'India' },
  {
    code: 'ID',
    dial_code: '+62',
    mask: '+62 (999) 999 9999',
    name: 'Indonesia'
  },
  {
    code: 'IR',
    dial_code: '+98',
    mask: '+98 (999) 999 9999',
    name: 'Iran, Islamic Republic of Persian Gulf'
  },
  { code: 'IQ', dial_code: '+964', mask: '+964 (999) 999 9999', name: 'Iraq' },
  {
    code: 'IE',
    dial_code: '+353',
    mask: '+353 (999) 999 999',
    name: 'Ireland'
  },
  {
    code: 'IM',
    dial_code: '+44',
    mask: '+44 9999 999999',
    name: 'Isle of Man'
  },
  {
    code: 'IL',
    dial_code: '+972',
    mask: '+972 999999999',
    name: 'Israel',
    min: 11
  },
  { code: 'IT', dial_code: '+39', mask: '+39 (999) 9999 999', name: 'Italy' },
  {
    code: 'JM',
    dial_code: '+1876',
    mask: '+1 (876) 999 9999',
    name: 'Jamaica'
  },
  {
    code: 'JP',
    dial_code: '+81',
    mask: '+81 9999999999',
    name: 'Japan',
    min: 11
  },
  { code: 'JE', dial_code: '+44', mask: '+44 9999 999999', name: 'Jersey' },
  { code: 'JO', dial_code: '+962', mask: '+962 9 9999 9999', name: 'Jordan' },
  {
    code: 'KZ',
    dial_code: '+77',
    mask: '+7 (999) 999 99 99',
    name: 'Kazakhstan'
  },
  { code: 'KE', dial_code: '+254', mask: '+254 999 999999', name: 'Kenya' },
  { code: 'KI', dial_code: '+686', mask: '+686 99 999', name: 'Kiribati' },
  {
    code: 'KP',
    dial_code: '+850',
    mask: '+850 99999999999999999',
    name: "Korea, Democratic People's Republic of Korea",
    min: 9
  },
  {
    code: 'KR',
    dial_code: '+82',
    mask: '+82 99 999 9999',
    name: 'Korea, Republic of South Korea'
  },
  { code: 'KW', dial_code: '+965', mask: '+965 9999 9999', name: 'Kuwait' },
  {
    code: 'KG',
    dial_code: '+996',
    mask: '+996 (999) 999 999',
    name: 'Kyrgyzstan'
  },
  {
    code: 'LA',
    dial_code: '+856',
    mask: '+856 999999999',
    name: 'Laos',
    min: 11
  },
  { code: 'LV', dial_code: '+371', mask: '+371 99 999 999', name: 'Latvia' },
  {
    code: 'LB',
    dial_code: '+961',
    mask: '+961 99999999',
    name: 'Lebanon',
    min: 10
  },
  { code: 'LS', dial_code: '+266', mask: '+266 9 999 9999', name: 'Lesotho' },
  { code: 'LR', dial_code: '+231', mask: '+231 99 999 999', name: 'Liberia' },
  {
    code: 'LY',
    dial_code: '+218',
    mask: '+218 99 999 9999',
    name: 'Libyan Arab Jamahiriya',
    min: 11
  },
  {
    code: 'LI',
    dial_code: '+423',
    mask: '+423 (999) 999 9999',
    name: 'Liechtenstein'
  },
  {
    code: 'LT',
    dial_code: '+370',
    mask: '+370 (999) 99 999',
    name: 'Lithuania'
  },
  {
    code: 'LU',
    dial_code: '+352',
    mask: '+352 (999) 999 999',
    name: 'Luxembourg'
  },
  { code: 'MO', dial_code: '+853', mask: '+853 9999 9999', name: 'Macao' },
  { code: 'MK', dial_code: '+389', mask: '+389 99 999 999', name: 'Macedonia' },
  {
    code: 'MG',
    dial_code: '+261',
    mask: '+261 99 99 99999',
    name: 'Madagascar'
  },
  {
    code: 'MW',
    dial_code: '+265',
    mask: '+265 999999999',
    name: 'Malawi',
    min: 11
  },
  { code: 'MY', dial_code: '+60', mask: '+60 9 9999 9999', name: 'Malaysia' },
  { code: 'MV', dial_code: '+960', mask: '+960 999 9999', name: 'Maldives' },
  { code: 'ML', dial_code: '+223', mask: '+223 99 99 9999', name: 'Mali' },
  { code: 'MT', dial_code: '+356', mask: '+356 9999 9999', name: 'Malta' },
  {
    code: 'MH',
    dial_code: '+692',
    mask: '+692 999 9999',
    name: 'Marshall Islands'
  },
  {
    code: 'MQ',
    dial_code: '+596',
    mask: '+596 (999) 99 99 99',
    name: 'Martinique'
  },
  {
    code: 'MR',
    dial_code: '+222',
    mask: '+222 99 99 9999',
    name: 'Mauritania'
  },
  { code: 'MU', dial_code: '+230', mask: '+230 999 9999', name: 'Mauritius' },
  { code: 'YT', dial_code: '+262', mask: '+262 9 9999 9999', name: 'Mayotte' },
  { code: 'MX', dial_code: '+52', mask: '+52 (999) 999 9999', name: 'Mexico' },
  {
    code: 'FM',
    dial_code: '+691',
    mask: '+691 999 9999',
    name: 'Micronesia, Federated States of Micronesia'
  },
  { code: 'MD', dial_code: '+373', mask: '+373 9999 9999', name: 'Moldova' },
  {
    code: 'MC',
    dial_code: '+377',
    mask: '+377 9999999999',
    name: 'Monaco',
    min: 11
  },
  { code: 'MN', dial_code: '+976', mask: '+976 99 99 9999', name: 'Mongolia' },
  {
    code: 'ME',
    dial_code: '+382',
    mask: '+382 99 999 999',
    name: 'Montenegro'
  },
  {
    code: 'MS',
    dial_code: '+1664',
    mask: '+1 (664) 999 9999',
    name: 'Montserrat'
  },
  { code: 'MA', dial_code: '+212', mask: '+212 99 9999 999', name: 'Morocco' },
  {
    code: 'MZ',
    dial_code: '+258',
    mask: '+258 99 999 999',
    name: 'Mozambique'
  },
  {
    code: 'MM',
    dial_code: '+95',
    mask: '+95 9999999999',
    name: 'Myanmar',
    min: 8
  },
  { code: 'NA', dial_code: '+264', mask: '+264 99 999 9999', name: 'Namibia' },
  { code: 'NR', dial_code: '+674', mask: '+674 999 9999', name: 'Nauru' },
  { code: 'NP', dial_code: '+977', mask: '+977 99 999 999', name: 'Nepal' },
  {
    code: 'NL',
    dial_code: '+31',
    mask: '+31 99 999 9999',
    name: 'Netherlands'
  },
  {
    code: 'AN',
    dial_code: '+599',
    mask: '+599 99999999',
    name: 'Netherlands Antilles',
    min: 10
  },
  {
    code: 'NC',
    dial_code: '+687',
    mask: '+687 99 9999',
    name: 'New Caledonia'
  },
  {
    code: 'NZ',
    dial_code: '+64',
    mask: '+64 999999999',
    name: 'New Zealand',
    min: 10
  },
  { code: 'NI', dial_code: '+505', mask: '+505 9999 9999', name: 'Nicaragua' },
  { code: 'NE', dial_code: '+227', mask: '+227 99 99 9999', name: 'Niger' },
  {
    code: 'NG',
    dial_code: '+234',
    mask: '+234 9999999999',
    name: 'Nigeria',
    min: 10
  },
  { code: 'NU', dial_code: '+683', mask: '+683 9999', name: 'Niue' },
  {
    code: 'NF',
    dial_code: '+672',
    mask: '+672 399 999',
    name: 'Norfolk Island'
  },
  {
    code: 'MP',
    dial_code: '+1670',
    mask: '+1 (670) 999 9999',
    name: 'Northern Mariana Islands'
  },
  { code: 'NO', dial_code: '+47', mask: '+47 (999) 99 999', name: 'Norway' },
  { code: 'OM', dial_code: '+968', mask: '+968 99 999 999', name: 'Oman' },
  {
    code: 'PK',
    dial_code: '+92',
    mask: '+92 (999) 999 9999',
    name: 'Pakistan'
  },
  { code: 'PW', dial_code: '+680', mask: '+680 999 9999', name: 'Palau' },
  {
    code: 'PS',
    dial_code: '+970',
    mask: '+970 99 999 9999',
    name: 'Palestinian Territory, Occupied'
  },
  { code: 'PA', dial_code: '+507', mask: '+507 999 9999', name: 'Panama' },
  {
    code: 'PG',
    dial_code: '+675',
    mask: '+675 (999) 99 999',
    name: 'Papua New Guinea'
  },
  {
    code: 'PY',
    dial_code: '+595',
    mask: '+595 (999) 999 999',
    name: 'Paraguay'
  },
  { code: 'PE', dial_code: '+51', mask: '+51 (999) 999 999', name: 'Peru' },
  {
    code: 'PH',
    dial_code: '+63',
    mask: '+63 (999) 999 9999',
    name: 'Philippines'
  },
  { code: 'PN', dial_code: '+872', mask: '+872 999999999', name: 'Pitcairn' },
  { code: 'PL', dial_code: '+48', mask: '+48 (999) 999 999', name: 'Poland' },
  { code: 'PT', dial_code: '+351', mask: '+351 99 999 9999', name: 'Portugal' },
  {
    code: 'PR',
    dial_code: '+1939',
    mask: '+1 (939) 99999999',
    name: 'Puerto Rico'
  },
  { code: 'QA', dial_code: '+974', mask: '+974 9999 9999', name: 'Qatar' },
  { code: 'RO', dial_code: '+40', mask: '+40 99 999 9999', name: 'Romania' },
  { code: 'RU', dial_code: '+7', mask: '+7 (999) 999 99 99', name: 'Russia' },
  { code: 'RW', dial_code: '+250', mask: '+250 (999) 999 999', name: 'Rwanda' },
  { code: 'RE', dial_code: '+262', mask: '+262 99999 9999', name: 'Reunion' },
  {
    code: 'BL',
    dial_code: '+590',
    mask: '+590 999999999',
    name: 'Saint Barthelemy'
  },
  {
    code: 'SH',
    dial_code: '+290',
    mask: '+290 9999',
    name: 'Saint Helena, Ascension and Tristan Da Cunha'
  },
  {
    code: 'KN',
    dial_code: '+1869',
    mask: '+1 (869) 999 9999',
    name: 'Saint Kitts and Nevis'
  },
  {
    code: 'LC',
    dial_code: '+1758',
    mask: '+1 (758) 999 9999',
    name: 'Saint Lucia'
  },
  {
    code: 'MF',
    dial_code: '+590',
    mask: '+590 999999999',
    name: 'Saint Martin'
  },
  {
    code: 'PM',
    dial_code: '+508',
    mask: '+508 999999',
    name: 'Saint Pierre and Miquelon'
  },
  {
    code: 'VC',
    dial_code: '+1784',
    mask: '+1 (784) 999 9999',
    name: 'Saint Vincent and the Grenadines'
  },
  { code: 'WS', dial_code: '+685', mask: '+685 99 9999', name: 'Samoa' },
  {
    code: 'SM',
    dial_code: '+378',
    mask: '+378 9999 999999',
    name: 'San Marino'
  },
  {
    code: 'ST',
    dial_code: '+239',
    mask: '+239 99 99999',
    name: 'Sao Tome and Principe'
  },
  {
    code: 'SA',
    dial_code: '+966',
    mask: '+966 999999999',
    name: 'Saudi Arabia'
  },
  { code: 'SN', dial_code: '+221', mask: '+221 99 999 9999', name: 'Senegal' },
  { code: 'RS', dial_code: '+381', mask: '+381 99 999 9999', name: 'Serbia' },
  { code: 'SC', dial_code: '+248', mask: '+248 9 999 999', name: 'Seychelles' },
  {
    code: 'SL',
    dial_code: '+232',
    mask: '+232 99 999999',
    name: 'Sierra Leone'
  },
  { code: 'SG', dial_code: '+65', mask: '+65 9999 9999', name: 'Singapore' },
  {
    code: 'SK',
    dial_code: '+421',
    mask: '+421 (999) 999 999',
    name: 'Slovakia'
  },
  { code: 'SI', dial_code: '+386', mask: '+386 99 999 999', name: 'Slovenia' },
  {
    code: 'SB',
    dial_code: '+677',
    mask: '+677 9999999',
    name: 'Solomon Islands',
    min: 8
  },
  {
    code: 'SO',
    dial_code: '+252',
    mask: '+252 999999999',
    name: 'Somalia',
    min: 10
  },
  {
    code: 'ZA',
    dial_code: '+27',
    mask: '+27 99 999 9999',
    name: 'South Africa'
  },
  {
    code: 'SS',
    dial_code: '+211',
    mask: '+211 99 999 9999',
    name: 'South Sudan'
  },
  {
    code: 'GS',
    dial_code: '+500',
    mask: '+500 99 999',
    name: 'South Georgia and the South Sandwich Islands'
  },
  { code: 'ES', dial_code: '+34', mask: '+34 (999) 999 999', name: 'Spain' },
  { code: 'LK', dial_code: '+94', mask: '+94 99 999 9999', name: 'Sri Lanka' },
  { code: 'SD', dial_code: '+249', mask: '+249 99 999 9999', name: 'Sudan' },
  {
    code: 'SR',
    dial_code: '+597',
    mask: '+597 999 9999',
    name: 'Suriname',
    min: 9
  },
  {
    code: 'SJ',
    dial_code: '+47',
    mask: '+47 99 99 99 99',
    name: 'Svalbard and Jan Mayen'
  },
  { code: 'SZ', dial_code: '+268', mask: '+268 99 99 9999', name: 'Swaziland' },
  { code: 'SE', dial_code: '+46', mask: '+46 99 999 9999', name: 'Sweden' },
  {
    code: 'CH',
    dial_code: '+41',
    mask: '+41 99 999 9999',
    name: 'Switzerland'
  },
  {
    code: 'SY',
    dial_code: '+963',
    mask: '+963 99 9999 999',
    name: 'Syrian Arab Republic'
  },
  { code: 'TW', dial_code: '+886', mask: '+886 9 99999999', name: 'Taiwan' },
  {
    code: 'TJ',
    dial_code: '+992',
    mask: '+992 99 999 9999',
    name: 'Tajikistan'
  },
  {
    code: 'TZ',
    dial_code: '+255',
    mask: '+255 99 999 9999',
    name: 'Tanzania, United Republic of Tanzania'
  },
  {
    code: 'TH',
    dial_code: '+66',
    mask: '+66 99 999 9999',
    name: 'Thailand',
    min: 10
  },
  {
    code: 'TL',
    dial_code: '+670',
    mask: '+670 999 99999',
    name: 'Timor-Leste',
    min: 10
  },
  { code: 'TG', dial_code: '+228', mask: '+228 99 999 999', name: 'Togo' },
  { code: 'TK', dial_code: '+690', mask: '+690 9999', name: 'Tokelau' },
  { code: 'TO', dial_code: '+676', mask: '+676 99999', name: 'Tonga' },
  {
    code: 'TT',
    dial_code: '+1868',
    mask: '+1 (868) 999 9999',
    name: 'Trinidad and Tobago'
  },
  { code: 'TN', dial_code: '+216', mask: '+216 99 999 999', name: 'Tunisia' },
  { code: 'TR', dial_code: '+90', mask: '+90 (999) 999 9999', name: 'Turkey' },
  {
    code: 'TM',
    dial_code: '+993',
    mask: '+993 9 999 9999',
    name: 'Turkmenistan'
  },
  {
    code: 'TC',
    dial_code: '+1649',
    mask: '+1 (649) 999 9999',
    name: 'Turks and Caicos Islands'
  },
  { code: 'TV', dial_code: '+688', mask: '+688 99999', name: 'Tuvalu' },
  { code: 'UG', dial_code: '+256', mask: '+256 (999) 999 999', name: 'Uganda' },
  {
    code: 'UA',
    dial_code: '+380',
    mask: '+380 (99) 999 99 99',
    name: 'Ukraine'
  },
  {
    code: 'AE',
    dial_code: '+971',
    mask: '+971 999999999',
    name: 'United Arab Emirates',
    min: 11
  },
  {
    code: 'GB',
    dial_code: '+44',
    mask: '+44 9999999999',
    name: 'United Kingdom'
  },
  {
    code: 'US',
    dial_code: '+1',
    mask: '+1 (999) 999 9999',
    name: 'United States'
  },
  { code: 'UY', dial_code: '+598', mask: '+598 9 999 99 99', name: 'Uruguay' },
  {
    code: 'UZ',
    dial_code: '+998',
    mask: '+998 99 999 9999',
    name: 'Uzbekistan'
  },
  { code: 'VU', dial_code: '+678', mask: '+678 9999999', name: 'Vanuatu' },
  {
    code: 'VE',
    dial_code: '+58',
    mask: '+58 (999) 999 9999',
    name: 'Venezuela, Bolivarian Republic of Venezuela'
  },
  { code: 'VN', dial_code: '+84', mask: '+84 99 9999 9999', name: 'Vietnam' },
  {
    code: 'VG',
    dial_code: '+1284',
    mask: '+1 (284) 999 9999',
    name: 'Virgin Islands, British'
  },
  {
    code: 'VI',
    dial_code: '+1340',
    mask: '+1 (340) 999 9999',
    name: 'Virgin Islands, U.S.'
  },
  {
    code: 'WF',
    dial_code: '+681',
    mask: '+681 99 9999',
    name: 'Wallis and Futuna'
  },
  { code: 'YE', dial_code: '+967', mask: '+967 9 999 999', name: 'Yemen' },
  { code: 'ZM', dial_code: '+260', mask: '+260 99 999 9999', name: 'Zambia' },
  { code: 'ZW', dial_code: '+263', mask: '+263 9 999999', name: 'Zimbabwe' }
];
